import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import styles from '../styles.module.scss';

export const BackForwardControls = ({
	children,
	rewindBack,
	rewindForward
}) => (
	<div className={styles.mainControls}>
		<button
			type="button"
			className={styles.forwardBackward}
			onClick={rewindBack}
			onKeyDown={rewindBack}
		>
			<span className={styles.secondsValue}>15</span>
			<Icon icon="audio-backButton" />
		</button>

		{children}

		<button
			type="button"
			className={styles.forwardBackward}
			onClick={rewindForward}
			onKeyDown={rewindForward}
		>
			<span className={styles.secondsValue}>15</span>
			<Icon icon="audio-forwardButton" />
		</button>
	</div>
);

BackForwardControls.propTypes = {
	children: PropTypes.element.isRequired,
	rewindBack: PropTypes.func.isRequired,
	rewindForward: PropTypes.func.isRequired
};
